import {get} from "lodash"
import {
  LOAD_RESULTS,
  PEND_LOAD_RESULTS,
  UPDATE_RESULTS,
  CLEAR_RESULTS,
  NEW_URL_QUERY_TERM,
  SET_SEARCH_RESULTS_INPUT,
  CLEAR_PEND
} from "../actions/SearchActions"

const SearchReducer = (state = {results: {total: 0}}, action) => {
  switch (action.type) {
    case NEW_URL_QUERY_TERM:
      return {
        ...state,
        q: get(action, "search.q", "")
      }
    case LOAD_RESULTS:
      return {
        ...state,
        load: get(action, "search.load")
      }
    case PEND_LOAD_RESULTS:
      return {
        ...state,
        load: new Promise(() => {})
      }
    case UPDATE_RESULTS:
      return {
        ...state,
        lastSuccessfulQ: get(action, "search.lastSuccessfulQ"),
        results: get(action, "search.results.data.results"),
        dealBrands: get(action, "search.dealBrands"),
        load: null
      }
    case CLEAR_RESULTS:
      return {
        ...state,
        load: null,
        lastSuccessfulQ: null,
        q: null,
        results: {
          deals: [],
          categories: []
        },
        dealBrands: []
      }
    case SET_SEARCH_RESULTS_INPUT:
      return {
        ...state,
        searchResultsInput: get(action, "search.input")
      }
    case CLEAR_PEND:
      return {
        ...state,
        load: null
      }
    default:
      return state
  }
}

export default SearchReducer
